export type RepresentationType =
  | 'default'
  | 'axes'
  | 'backbone'
  | 'ball+stick'
  | 'base'
  | 'cartoon'
  | 'contact'
  | 'distance'
  | 'helixorient'
  | 'hyperball'
  | 'label'
  | 'licorice'
  | 'line surface'
  | 'ribbon'
  | 'rocket'
  | 'rope'
  | 'spacefill'
  | 'trace'
  | 'tube'
  | 'unitcell';

export const RepresentationTypeValues: RepresentationType[] = [
  'default',
  'axes',
  'backbone',
  'ball+stick',
  'base',
  'cartoon',
  'contact',
  'distance',
  'helixorient',
  'hyperball',
  'label',
  'licorice',
  'line surface',
  'ribbon',
  'rocket',
  'rope',
  'spacefill',
  'trace',
  'tube',
  'unitcell',
];
